import React, { useState, useMemo } from "react";

import { Check } from "icons";

import {
  Modal,
  PageLoader,
  Typography,
  Button,
} from "clearsense-ui/components";
import useJobResultData from "hooks/useJobResultData";

import Chart from "./Chart";
import { getPlots } from "./data";

const ChartModal = ({
  isOpen,
  onClose,
  outputs,
  setOutputs,
  modelDrivers,
  node,
}) => {
  const [targetPlotSelected, setTargetPlotSelected] = useState(false);

  const { data: modelPlots, loading: modelPlotsLoading } = useJobResultData(
    outputs,
    setOutputs,
    "model_plots"
  );

  const plots = useMemo(
    () =>
      modelPlots?.plots?.length &&
      node?.type === "input" &&
      getPlots(modelPlots.plots, modelDrivers.variable_list, node),
    [modelPlots, node]
  );

  return (
    <Modal onClose={onClose} isOpen={isOpen} size="md" className="w-[80vw]">
      <Modal.Header className="px-5 py-4 bg-gray-200">
        <Typography type="semibold">{node?.data.label}</Typography>
      </Modal.Header>
      <Modal.Body className="p-0">
        <div className="flex justify-end w-full px-5 py-2 bg-gray-100">
          <Button
            label="Count Distribution"
            size="small"
            style="secondary"
            className="mr-2 text-sm"
            icon={targetPlotSelected ? undefined : Check}
            iconPosition="right"
            onClick={() => setTargetPlotSelected(false)}
            disabled={!targetPlotSelected}
          />
          <Button
            label="Distribution against Target"
            size="small"
            style="secondary"
            className="text-sm"
            icon={targetPlotSelected ? Check : undefined}
            iconPosition="right"
            onClick={() => setTargetPlotSelected(true)}
            disabled={targetPlotSelected}
          />
        </div>
        {modelPlotsLoading ? (
          <div className="h-32">
            <PageLoader />
          </div>
        ) : (
          <div className="p-5">
            <Chart
              plot={
                targetPlotSelected
                  ? plots.distributionAgainstTarget
                  : plots.countDistribution
              }
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ChartModal;
